export enum ActionRisposte {
    show = 'show',
    hidden = 'hidden'
}